import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { AutoPointInsertRequest } from "./AutoPointInsertRequest";
import { AutoPointModifyRequest } from "./AutoPointModifyRequest";

@Injectable()
export class DataService_PBISAuto {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	AutoPointInfoSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/AutoPointInfoSelectList?SchoolID=" + SchoolID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AutoPointInsert(parms: AutoPointInsertRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/AutoPointInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AutoPointModify(parms: AutoPointModifyRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/AutoPointModify";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AutoPointDelete(PointsAutomatedItemTypeID, PointsItemID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/AutoPointDelete?PointsAutomatedItemTypeID=" + PointsAutomatedItemTypeID + "&PointsItemID=" + PointsItemID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AutoPointTriggerSelectList() {
		var postResult$ = new Subject();
		var url = "SchoolSetup/AutoPointTriggerSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AutoPointPBISSelectList() {
		var postResult$ = new Subject();
		var url = "SchoolSetup/AutoPointPBISSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
